var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('span',{staticClass:"badge",style:({
    'background-color': this.getBackgroundColor(),
    'color': this.getColor(),
  })},[_vm._v(_vm._s(_vm.statusLabel))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }